/**
 * This enum lists every different type of inner ionic component where the stucture of the app project made impossible to
 * handle locally a possible error in data fetching through "app-error-content.component". This is usally due to the necessity
 * to avoid a circular dependency problem.
 */
export enum InnerComponentDataError {
    LIST_NOTIFICATIONS = 0,
    LIST_SCENARIOS = 1,
    LIST_CALENDARS = 2,
    LIST_USERS = 3,
    LIST_ENVIRONMENTS = 4
}